import { Box, ButtonIcon, Flex, IconX, Text } from '@cmpsr/components';
import useCompletedAssessmentController from './assessment-completed.controller';

export default function CompletedAssessment() {
  const { assessmentStatus, dismissBanner } = useCompletedAssessmentController();

  if (!assessmentStatus || assessmentStatus === 'dismissed') return null;

  return (
    <Box
      pt="spacer-4"
      pr="spacer-4"
      pb={{ base: 'spacer-6', lg: 'spacer-9' }}
      pl={{ base: 'spacer-6', lg: 'spacer-8' }}
      textAlign="left"
      borderRadius="radii-3"
      backgroundColor="alert-success-default"
    >
      <Flex justifyContent="space-between" alignItems="baseline">
        <Text variant="text-header-XS" textTransform="uppercase" mb="spacer-2">
          assessment completed
        </Text>
        <ButtonIcon
          variant="primary-alt"
          size={{ base: 's', lg: 'm' }}
          icon={<IconX />}
          aria-label="Closing button for Assessment Completed banner"
          onClick={dismissBanner}
        />
      </Flex>
      <Text variant="text-header-XL" mb="spacer-5">
        100%
      </Text>
      <Text variant="text-body-regular" pr="spacer-4">
        Thank you for completing your Risk Assessment. This information is used to calculate your personalized Risk
        Scores and populate your Action Plan and Testing Plan. You can update your responses at any time through your
        user profile.
      </Text>
    </Box>
  );
}
